<template>

  <svg class="svg-node"><!-- 加号 -->
    <g transform="translate(0.5,0.5)" style="visibility: visible">
      <polygon
        points="0,9 9,9 9,0 18,0 18,9 27,9 27,18 18,18 18,27 9,27 9,18 0,18"
        fill="#ffffff"
        stroke="#000000"
        stroke-width="1.3"
        pointer-events="all"
      ></polygon>
    </g>
  </svg>
</template>

<script>
export default {
}
</script>